import React, { Component, createRef, useState } from "react";
import HanaHeader from "components/header/HanaHeader";
import DonutChart from "components/DonutChart";
import { CengoldModal } from "components/CengoldModal";
import { Swiper, SwiperSlide } from "swiper/react";
import { TradeHistory } from "pages";
import {
  ic_e_gold_img,
  ic_e_gold_text_b,
  ic_e_silver_img,
  ic_e_silver_text_b,
  ic_buy_white,
  ic_sell_navy,
  ic_gold_point,
  ic_silver_point,
  btn_more,
  ic_info_red,
  img_tooltip,
  img_link_service_stop,
  //pop_logo,
  //img_product_notice_hana,
} from "../../styles/img";
import { AreaChart, Area, ResponsiveContainer, YAxis } from "recharts";
import * as API from "lib/apis";
import { CHART_COLOR } from "constants/index";
import Loader from "components/Loader";
import { numberWithCommas, hanaWebviewExit } from "lib/utils";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useLocalStorage } from "../../lib/useLocalStorage";

const INIT_STATE = {
  isLoading: true,
  priceTrend: { peg: [], pes: [] },
  currentPrice: { peg: 0, pes: 0 },
  info: {},
  histories: [],
  cengoldModalVisible: false,
};
class HanaMain extends Component {
  constructor(props) {
    super(props);
    this.clickRef = createRef(false);
  }
  state = { ...INIT_STATE };

  componentDidMount() {
    this.apiCall();
    document.getElementById("main_el").style.height = "100%";
    document.getElementById("main_el").focus();
    document.addEventListener("click", this.onClickTip);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.histories !== this.state.histories) {
      document.getElementById("main_el").focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickTip);
  }

  handleClickInfo = (e) => {
    e.stopPropagation();
    const el = document.getElementById("info");
    if (!this.clickRef.current) {
      el.style.display = "block";
      this.clickRef.current = true;
    } else {
      el.style.display = "none";
      this.clickRef.current = false;
    }
  };

  apiCall = async () => {
    const newState = { ...INIT_STATE, isLoading: false };
    const apiInfo = API.getInfo(({ data, errorMessage }) => {
      newState["info"] = data || {};
      errorMessage && alert(errorMessage);
    });
    const apiPrice = API.getCurrentPrice(({ data, errorMessage }) => {
      newState["currentPrice"] = data || {};
      errorMessage && alert(errorMessage);
    });
    const apiPriceTrend = API.getPriceTrend(({ data, errorMessage }) => {
      newState["priceTrend"] = data || {};
      errorMessage && alert(errorMessage);
    }, 30);
    const apiHistories = API.getHistories(({ data, errorMessage }) => {
      newState["histories"] = data || ["aaaa", "bbb"];
      errorMessage && alert(errorMessage);
    });

    Promise.all([apiInfo, apiHistories, apiPrice, apiPriceTrend]).then(() =>
      this.setState(newState)
    );
  };

  onClickTip = (e) => {
    const el = document.getElementById("info");
    const target = document.getElementById("info-red");
    if (this.clickRef.current && e.target !== target) {
      el.style.display = "none";
      this.clickRef.current = false;
    }
  };

  navigateBuyInfo = (type) => {
    // window.location.href=`/hana-buy-info?serviceCode=${this.props.serviceCode}&type=${type}`;

    this.props.history.push(
      `/hana-buy-info?serviceCode=${this.props.serviceCode}&type=${type}`
    );
  };

  handleRefresh = async () => {
    this.setState({ isLoading: true });

    const newState = { ...INIT_STATE, isLoading: false };
    const apiInfo = API.getInfo(({ data, errorMessage }) => {
      newState["info"] = data || {};
      errorMessage && alert(errorMessage);
    });
    const apiPrice = API.getCurrentPrice(({ data, errorMessage }) => {
      newState["currentPrice"] = data || {};
      errorMessage && alert(errorMessage);
    });
    const apiPriceTrend = API.getPriceTrend(({ data, errorMessage }) => {
      newState["priceTrend"] = data || {};
      errorMessage && alert(errorMessage);
    }, 30);
    const apiHistories = API.getHistories(({ data, errorMessage }) => {
      newState["histories"] = data || [];
      errorMessage && alert(errorMessage);
    });

    return Promise.all([apiInfo, apiHistories, apiPrice, apiPriceTrend]).then(
      () => this.setState(newState)
    );
  };

  render() {
    const handleStorage = {
      setStorage: function (name, exp) {
        let date = new Date();
        date = date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);

        localStorage.setItem(name, date);
      },
      getStorage: function (name) {
        if (!localStorage.getItem(name)) return false;
        let now = new Date();
        now = now.setTime(now.getTime());
        return parseInt(localStorage.getItem(name)) > now;
      },
    };

    const {
      isLoading,
      priceTrend,
      currentPrice,
      info,
      histories,
      cengoldModalVisible,
    } = this.state;

    const { isFirstLoad, setIsFirstLoad } = this.props;
    console.log(isFirstLoad);
    const { ocbPoint = 0, balance = {}, profit = {} } = info;

    const { peg: pegBalance = 0, pes: pesBalance = 0 } = balance; // 보유 자산
    const { pegPrice = 0, pesPrice = 0 } = currentPrice; // 시세
    const { peg: pegProfit = {}, pes: pesProfit = {} } = profit;

    const { gainAverage: pegAverage = 0 } = pegProfit; // e금 평균 구매 금액
    const { gainAverage: pesAverage = 0 } = pesProfit; // e은 평균 구매 금액

    const pegCurrentValue = parseInt(pegBalance * pegPrice); // 현재 e금 평가금액
    const pesCurrentValue = parseInt(pesBalance * pesPrice); // 현재 e은 평가금액
    const totalCurrentValue = pegCurrentValue + pesCurrentValue; // 현재 총 평가금액

    const pegBuyValue = parseInt(pegBalance * pegAverage); // e금 매수금액
    const pesBuyValue = parseInt(pesBalance * pesAverage); // e은 매수금액
    const totalBuyValue = pegBuyValue + pesBuyValue; // 총 매수금액

    const totalDiffValue = totalCurrentValue - totalBuyValue; // 총 수익금액
    const diffPer = (totalDiffValue / totalBuyValue || 0) * 100; // 총 수익 퍼센트

    const pegDiffValue = pegCurrentValue - pegBuyValue;
    const pesDiffValue = pesCurrentValue - pesBuyValue;

    let opClass = "per";
    let opText = "";
    if (totalDiffValue > 0) {
      opClass = "per plus";
      opText = `▲ +${diffPer.toFixed(2)}%`;
    } else if (totalDiffValue < 0) {
      opClass = "per minus";
      opText = `▼ ${diffPer.toFixed(2)}%`;
    }

    const slideBalance = {
      peg: {
        balance: pegBalance,
        currentValue: pegCurrentValue,
        diffValue: pegDiffValue,
        price: pegPrice,
      },
      pes: {
        balance: pesBalance,
        currentValue: pesCurrentValue,
        diffValue: pesDiffValue,
        price: pesPrice,
      },
    };
    return (
      <>
        {isLoading && <Loader isFixed={false} />}

        <div className="wrap hana_wrap" id="main_el" style={{ padding: 0 }}>
          <PullToRefresh
            onRefresh={this.handleRefresh}
            pullingContent={<></>}
            maxPullDownDistance={100}
            pullDownThreshold={100}
          >
            <div className="section">
              <div className="content product_hana">
                <HanaHeader point={+ocbPoint} />

                <div className="portf">
                  {/* img */}
                  <div onClick={this.handleClickInfo}>
                    <img
                      src={ic_info_red}
                      id="info-red"
                      className="to_btn"
                      alt="info"
                    />
                  </div>
                  <div
                    className="to_form"
                    id="info"
                    style={{ display: "none" }}
                  >
                    {/* <div className="to_close wrap_area"> </div> */}
                    <img
                      src={img_tooltip}
                      className="img_to_bg"
                      alt="tooltip"
                    />
                    <div className="noto to_close">
                      <div className="tooltip-message">
                        <ul>
                          <li>
                            <span style={{ fontSize: "0.7333rem" }}>
                              비단 앱에서 제공하는 상품기준가를 기준으로 현재가
                              및 등락률이 제공되고, 평가금액이 산정됩니다.
                            </span>
                          </li>
                          <li style={{ marginTop: "4px" }}>
                            <span style={{ fontSize: "0.7333rem" }}>
                              비단 앱의 현재가(고객 간 체결시세)를 기준으로 한
                              평가금액과 다를 수 있습니다.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* img */}
                  <DonutChart
                    gold={pegCurrentValue}
                    silver={pesCurrentValue}
                    isLoading={isLoading}
                  />
                  <div className="portf_info">
                    <p className="tt1">
                      <span className={opClass}>{opText}</span>{" "}
                    </p>
                    <p className="tt2">
                      <em>{numberWithCommas(totalCurrentValue)}</em> KRW
                    </p>
                    <p className="tt3">
                      <img src={ic_gold_point} alt="e금 그림 아이콘" />
                      e금 <img src={ic_silver_point} alt="e금 그림 아이콘" />
                      e은
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="main_slide">
              <MoneySlide
                navigateBuyInfo={this.navigateBuyInfo}
                priceTrend={priceTrend}
                balance={slideBalance}
              />
            </div>

            <div className="btn_more apply_btn3 MB24">
              <span
                onClick={() => {
                  this.setState({ cengoldModalVisible: true });
                }}
                className="pop"
              >
                비단 바로가기 <img src={btn_more} alt="더보기" />
              </span>
            </div>

            <div className="par_line" />
            <TradeHistory histories={histories} />

            <div className="section bg_gray PB60">
              <div className="content">
                <div className="notice">
                  <h3 className="stit">이용안내</h3>
                  <div className="noti_wrap">
                    <ul>
                      <li>
                        본 투자 서비스는 ㈜비단골드가 운영하는 “비단” 앱에서
                        제공하는 것입니다.
                      </li>
                      <li>
                        본 투자 서비스를 이용하시기 전 제공되는 정보에 대해
                        꼼꼼히 확인해 주시기 바랍니다.
                      </li>
                      <li>
                        “e금”, “e은”은 순도 99.99%의 실물 금, 은을 제공 받을 수
                        있는 모바일 상품권으로 국제시세, 환율 및 국내 시장환경을
                        고려해 책정한 상품기준가로 매수할 수 있습니다.
                      </li>
                      <li>
                        “e금”, “e은” 시세의 급등락에 따른 손실이 발생할 수
                        있으므로, 거래 시 유의하시기 바랍니다.
                      </li>
                      <li>
                        “e금”, “e은”은 시세에 따라 가치가 변화되는 만큼 구매한
                        “e금”, “e은”에 대해 환불은 되지않습니다.
                      </li>
                      <li>
                        회원이 구매한 “e금”, “e은”의 매도는 “비단” 앱에서만
                        가능합니다.
                      </li>
                      <li>
                        “e금”, “e은” 평가금액은 상품기준가를 기초하여 평가한
                        것으로, “비단“ 앱의 평가금액과 다를 수 있습니다.
                      </li>
                      <li>
                        “비단” 앱에서는 현재가에 기초하여 보유자산에 대한 평가가
                        이루어집니다.
                      </li>
                      <li>
                        “비단” 앱에서 매도를 할 경우, 고객 간 호가거래 또는
                        상품기준가(단일가거래)로 거래 가능합니다.
                      </li>
                      <li>
                        “비단” 앱에서 제공하는 거래수수료는 제휴사 매수수수료
                        정책과 무관합니다.
                      </li>
                      <li>
                        기타 “e금”, “e은” 거래와 관련한 상세한 설명은 “비단”
                        앱서비스를 참고하시기 바랍니다.
                      </li>
                      <li>
                        상세한 문의는 “비단” 앱 서비스 고객센터 02-1670-8456으로
                        문의 바랍니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </PullToRefresh>
          <div className="btn_area fixed apply_btn" style={{ zIndex: 10 }}>
            <div className="bt_col1">
              <input
                type="button"
                value="하나머니 돌아가기"
                className="navy pop noto-medium"
                onClick={hanaWebviewExit}
              />
            </div>
          </div>
        </div>
        <CengoldModal
          visible={cengoldModalVisible}
          title={"비단 앱 바로가기"}
          onClose={() => {
            this.setState({ cengoldModalVisible: false });
          }}
        >
          <div>비단 앱에서 더욱 다양한 서비스를</div>
          <div>이용하실 수 있습니다.</div>
        </CengoldModal>
        {/* {isFirstLoad && !handleStorage.getStorage("done") && (
          <MainPopup
            onClose={() => {
              setIsFirstLoad(false);
            }}
            onDayClose={() => {
              setIsFirstLoad(false);
              handleStorage.setStorage("done", 1);
            }}
          />
        )} */}
      </>
    );
  }
}

const MoneySlide = ({
  navigateBuyInfo,
  priceTrend: { peg = [], pes = [] },
  balance: { peg: pegBalance = {}, pes: pesBalance = {} },
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const handleClickSell = () => {
    setModalVisible(true);
  };
  return (
    <div className="section">
      <Swiper spaceBetween={20} slidesPerView={1.1}>
        <SwiperSlide>
          <SlideCard
            type="peg"
            onClickSell={handleClickSell}
            onClickBuy={navigateBuyInfo}
            chartData={peg}
            data={pegBalance}
          />
        </SwiperSlide>
        <SwiperSlide>
          <SlideCard
            type="pes"
            onClickSell={handleClickSell}
            onClickBuy={navigateBuyInfo}
            chartData={pes}
            data={pesBalance}
          />
        </SwiperSlide>
      </Swiper>
      <CengoldModal
        visible={modalVisible}
        title={"비단 앱 바로가기"}
        onClose={() => {
          setModalVisible(false);
        }}
      >
        <div>비단 앱에서 더욱 다양한 서비스를</div>
        <div>이용하실 수 있습니다.</div>
      </CengoldModal>
    </div>
  );
};

const SlideCard = ({ onClickSell, onClickBuy, type, chartData, data = {} }) => {
  const stroke = CHART_COLOR["STROKE"][type];
  const gradient = CHART_COLOR["GRADIENT"][type];

  const iconImage = type === "peg" ? ic_e_gold_img : ic_e_silver_img;
  const textImage = type === "peg" ? ic_e_gold_text_b : ic_e_silver_text_b;
  const altText = type === "peg" ? "e금" : "e은";
  const cssText = type === "peg" ? "gold" : "silver";

  const { balance, currentValue, diffValue, price } = data;

  let opClass = "right";
  let opText = 0;

  if (diffValue > 0) {
    opClass = "right plus";
    opText = `▲ ${numberWithCommas(Math.abs(diffValue))}`;
  } else if (diffValue < 0) {
    opClass = "right minus";
    opText = `▼ ${numberWithCommas(Math.abs(diffValue))}`;
  }
  return (
    <div className="e_product">
      <div className="e_box1">
        <div className="F_box">
          <div className="FL">
            <img src={iconImage} alt={`${altText} 그림 아이콘`} />
          </div>

          <div className="FR">
            <img src={textImage} alt={`${altText} 텍스트 아이콘`} />
            <p className="my_gram">
              {numberWithCommas(balance)}
              <span>g</span>
            </p>
          </div>
        </div>
      </div>

      <div className="e_box2" style={{ backgroundColor: "white" }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id={`color${type}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={gradient} stopOpacity={1} />
                <stop offset="100%" stopColor="#FFFFFF" stopOpacity={1} />
              </linearGradient>
            </defs>
            <YAxis domain={["dataMin", "dataMax"]} width={0} />
            <Area
              type="monotone"
              dataKey="price"
              stroke={stroke}
              strokeWidth={0.5}
              fill={`url(#color${type})`}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="e_box3">
        <div className="F_box">
          <div className="FL">
            <ul>
              <li>
                <span className="left">평가금액</span>
                <span className="right">
                  <em className="now">{numberWithCommas(currentValue)} </em>
                  <em className="now2">KRW</em>
                </span>
              </li>
              <li>
                <span className="left">평가수익</span>
                <span className={opClass}>
                  <em className="plus">{opText} </em>
                  <em className="krw">KRW</em>
                </span>
              </li>
            </ul>
          </div>
          <div className="FR">
            <span className={`today_price ${cssText}`}>
              <em>{numberWithCommas(price)}</em> KRW
            </span>
          </div>
        </div>
      </div>

      <div className="e_box4">
        <div className="btn_area">
          <ul>
            <li>
              <span
                onClick={() => {
                  onClickBuy(type);
                }}
                className="buy"
              >
                <img src={ic_buy_white} alt="" /> 매수
              </span>
            </li>
            <li className="apply_btn">
              <span className="sell pop" onClick={onClickSell}>
                {" "}
                <img src={ic_sell_navy} alt="" />
                매도
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const MainPopup = ({ onClose, onDayClose }) => {
  return (
    <div className="apply_form center" style={{ display: "block" }}>
      <div className="hm_popup">
        <div className="pop_ct">
          <img
            src={img_link_service_stop}
            alt=""
            style={{ width: "100%", verticalAlign: "top" }}
          />
        </div>
        <div class="bottom_bt">
          <button className="close01" onClick={onDayClose}>
            오늘 하루 보지않기
          </button>
          <button className="close" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default HanaMain;
